import React, { useRef, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Btn } from "@/components/erp/ui";
import { FileSpreadsheet, Upload } from "lucide-react";

export const ExcelIO = ({ kind, onDone, label = "" }) => {
  const ref = useRef(null); const [busy, setBusy] = useState(false);
  const tpl = async () => {
    try { const { data } = await api.get(`/import/${kind}/template`, { responseType: "blob" }); const u = URL.createObjectURL(data); const a = document.createElement("a"); a.href = u; a.download = `template-${kind}.xlsx`; a.click(); setTimeout(() => URL.revokeObjectURL(u), 1000); } catch { toast.error("Gagal mengunduh template"); }
  };
  const up = async (e) => {
    const f = e.target.files?.[0]; e.target.value = "";
    if (!f) return;
    const fd = new FormData(); fd.append("file", f); setBusy(true);
    try {
      const { data } = await api.post(`/import/${kind}`, fd);
      toast.success(`Upload selesai: ${data.created} baru, ${data.updated} diperbarui${data.errors.length ? `, ${data.errors.length} gagal` : ""}`, { duration: 8000 });
      if (data.errors.length) toast.error(data.errors.slice(0, 5).join("\n"), { duration: 12000 });
      onDone?.();
    } catch (x) { toast.error(x?.response?.data?.detail || "Upload gagal"); } finally { setBusy(false); }
  };
  return (
    <span className="inline-flex gap-2">
      <Btn variant="ghost" data-testid={`xl-template-${kind}`} onClick={tpl} title="Template berisi data yang sudah ada — ubah/tambah baris lalu upload"><FileSpreadsheet className="w-4 h-4" /> Template Excel{label}</Btn>
      <Btn variant="ghost" data-testid={`xl-upload-${kind}`} disabled={busy} onClick={() => ref.current?.click()}><Upload className="w-4 h-4" /> {busy ? "Mengupload…" : `Upload Excel${label}`}</Btn>
      <input ref={ref} type="file" accept=".xlsx" className="hidden" data-testid={`xl-file-${kind}`} onChange={up} />
    </span>
  );
};
